// eslint-disable-next-line import/no-extraneous-dependencies
import { Component, OnInit, input } from "@angular/core";
import { ICorrListItem } from "@api/model/iCorrListItem";
import { getIcon, getStatusText } from "@shared/utils";

@Component({
  selector: "corrHeader",
  templateUrl: "./corrHeader.component.html",
  styleUrls: ["./corrHeader.component.scss"],
  standalone: false
})
export default class CorrHeaderComponent implements OnInit {
  readonly corr = input<ICorrListItem>(undefined);

  readonly IsDbAdmin = input(false);

  number: string;

  icon: string;

  status: string;

  ngOnInit(): void {
    this.number = this.corr().CorrespondenceNumber;
    this.status = getStatusText(
      this.corr().Status,
      this.IsDbAdmin()
    );
    this.icon = getIcon(
      this.corr().Status,
      this.IsDbAdmin()
    );
  }
}